// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2tsqD","tab":"ProcedureTabs_tab__1AFCk"};